<template>
    <div class="com-footer">
        <img src="/static/images/footer-img.png" alt="" srcset="">
        <div class="txt">
            <p class="t1">通讯地址</p>
            <p>浙江省 杭州市 西湖区 南山路56号</p>
            <p>邮编：310000</p>
            <br>
            <p class="t1">客堂电话</p>
            <p>
                <a href="tel:0571-87995600">0571-87995600</a>
            </p>
            <br>
            <p class="t1">在线联络</p>
            <p>
                <svg class="wx" aria-hidden="true" @click="toChart">
                    <use xlink:href="#icon-weixin-copy" />
                </svg>
            </p>
        </div>
    </div>
</template>

<script>
    import { CHAT_URL } from '@/config'
    export default {
        data () {
            return {
                
            }
        },
        created () {
            
        },
        methods: {
            toChart () {
              window.location.href = CHAT_URL
            }
        },
        components: {
            
        }
    }
</script>